import { createStore } from 'vuex';
import CONFIG from '@/config';
export default createStore({
    state: {
        link: 0,
        loading: false,
        mobile: document.body.clientWidth <= 768,
        ...CONFIG,

        btz: {
            // url: 'http://124.235.168.2:8100',
            url: 'http://219.150.29.133:8100/',
            name: '大众物流库存账务查询系统'
        }
    },
    mutations: {
        //修改值
        set(state, data) {
            for (let k in data) {
                state[k] = data[k];
            }
        }
    },
    strict: false,
    actions: {},
    modules: {}
});
